import { render, staticRenderFns } from "./EditPayer.vue?vue&type=template&id=f681607a&scoped=true&"
import script from "./EditPayer.vue?vue&type=script&lang=js&"
export * from "./EditPayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f681607a",
  null
  
)

export default component.exports